import { lazy } from "react";

const list = lazy(() => import("./List").then(m => ({ default: m.PersonList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.PersonCreate })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.PersonEdit })));

export default { list, create, edit };
